import { render, staticRenderFns } from "./commonShare.vue?vue&type=template&id=c94338b2&"
import script from "./commonShare.vue?vue&type=script&lang=js&"
export * from "./commonShare.vue?vue&type=script&lang=js&"
import style0 from "./commonShare.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports